import { useState } from "react";
import { useUsers } from "@/context/UsersContext";

type DeleteUserButtonProps = {
  userId: number;
};

export default function DeleteUserButton({ userId }: DeleteUserButtonProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [confirming, setConfirming] = useState(false);
  const { deleteUser, fetchUsers } = useUsers();

  const handleDelete = async () => {
    if (!confirming) {
      setConfirming(true);
      return;
    }

    setLoading(true);
    setError("");

    try {
      await deleteUser(userId);
      await fetchUsers();
      setConfirming(false);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "Errore durante l'eliminazione";
      setError(msg);
      setConfirming(false);
    } finally {
      setLoading(false);
    }
  };

  const label = loading
    ? "Eliminando…"
    : error
      ? "Errore"
      : confirming
        ? "Conferma"
        : "Elimina";

  return (
    <button
      type="button"
      onClick={handleDelete}
      disabled={loading}
      title={error || undefined}
      className={`inline-flex flex-1 items-center justify-center gap-2 rounded-xl border px-4 py-2.5 text-sm font-semibold transition md:flex-none ${
        confirming
          ? "border-red-300 bg-red-600 text-white hover:bg-red-700"
          : "border-red-200 bg-red-50 text-primary hover:border-red-300 hover:bg-red-100"
      } disabled:cursor-not-allowed disabled:opacity-60`}
    >
      <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
      {label}
    </button>
  );
}
